<template>
  <v-footer
    class="footer"
    padless
  >
    <v-card
      class="footer-container"
      flat
      tile
    >
      <section class="footer-top">
        <div
          style="height: 45px"
        >
        <v-img
          :src="footerLogo"
        ></v-img>
        </div>
        <v-list
          class="footer-list"
          dense
        >
          <section class="footer-list__items">
            <v-list-item-group
              v-for="(menu, m) in menus"
              :key="`menu_${m}`"
              class="footer-list__group"
            >
              <v-list-item-title class="footer-list__title">
                {{ menu.title }}
              </v-list-item-title>
              <v-list-item
                v-for="(item, i) in menu.menu"
                :key="`menu_${m}_item_${i}`"
                class="footer-list__item"
              >
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </section>
          <section class="footer-buttons">
            <Button
              class="footer-buttons__item"
              width="130px"
              @click="registerModal"
            >
              Criar Conta
            </Button>
            <Button
              class="footer-buttons__item"
              width="130px"
              font-color="#EE396C"
              border-color="#EE396C"
              background-color="#ffffff"
              padding="0"
              @click="loginModal"
            >
              Acessar Conta
            </Button>
          </section>
        </v-list>
      </section>

      <section class="footer-bottom">
        <v-divider></v-divider>
        <v-card-title class="footer-bottom__copy">
          <span> © Spiti.Art. {{ new Date().getFullYear() }}. O melhor leilão de arte </span>

          <v-spacer></v-spacer>
          <span>Siga a Spiti.art</span>
          <div class="buttons">
            <v-btn
              v-for="icon in icons"
              :key="icon"
              class="mx-4"
              icon
            >
              <v-icon size="24px">
                {{ icon }}
              </v-icon>
            </v-btn>
          </div>
        </v-card-title>
      </section>
    </v-card>
  </v-footer>
</template>

<script>
import RegisterMixin from '@/mixins/RegisterMixin';
import Button from '@/components/Button/Button.vue';

export default {
  name: 'Footer',
  components: { Button },
  mixins: [RegisterMixin],
  data: () => ({
    footerLogo: require('../../assets/spitiart-logo.svg'),
    icons: ['mdi-facebook', 'mdi-twitter', 'mdi-linkedin', 'mdi-instagram'],
    menus: [
      {
        title: 'Mobile app',
        menu: [{ text: 'Features' }, { text: 'Live share' }, { text: 'Video record' }],
      },
      {
        title: 'Community',
        menu: [{ text: 'Featured artists' }, { text: 'The Portal' }, { text: 'Live events' }],
      },
      {
        title: 'Company',
        menu: [{ text: 'About us' }, { text: 'Contact Us' }, { text: 'History' }],
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.footer {
  max-width: initial;
  width: 100%;
  margin: 130px auto 30px;
  @media (max-width: $md) {
    width: 100%;
    flex-direction: column;
    margin: 20px auto;
  }

  &-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 80px 0px;
    padding-top: 0;
    @media (max-width: $md) {
      padding: 20px 0px;
    }
  }

  &-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 50px;

    @media (max-width: $lg) {
      flex-direction: column;
      align-items: center;

      > .v-image {
        @media (max-width: $lg) {
          margin-bottom: 20px;
        }
      }
    }
  }

  &-bottom {
    width: 100%;

    &__copy {
      font-size: 15px;
      line-height: 24px;
      letter-spacing: -0.015em;
      color: rgba(0, 0, 0, 0.8);

      @media (max-width: $sm) {
        flex-direction: column;
      }
    }
  }
  &-list {
    display: flex;
    @media (max-width: $md) {
      width: 100%;
      flex-direction: column;
    }
    &__items {
      margin-right: 115px;
      display: flex;

      @media (max-width: $md) {
        width: 100%;
        margin-right: 0;
        justify-content: space-between;
        flex-wrap: wrap;
      }
    }
    &__group {
      @media (max-width: $sm) {
        padding: 0 20px;
      }
      & + .footer-list__group {
        margin-left: 80px;
        @media (max-width: $sm) {
          margin-left: 0;
        }
      }
    }
    &__title {
      font-size: 15px;
      line-height: 24px;
      font-weight: 700;
      letter-spacing: -0.015em;
      margin-bottom: 15px;
    }
    &__item {
      padding: 0;
    }
  }

  &-buttons {
    display: flex;
    flex-direction: column;

    @media (max-width: $md) {
      flex-direction: row;
      justify-content: space-between;
      margin-top: 15px;
    }
    @media (max-width: $sm) {
      padding: 0 20px;
      flex-direction: column;
      width: 100% !important;
    }
    &__item {
      @media (max-width: $sm) {
        width: 100% !important;
      }
      & + button {
        margin-top: 15px;
        @media (max-width: $md) {
          margin-top: inherit;
          margin-top: 0;
        }
        @media (max-width: $sm) {
          margin-top: inherit;
        }
      }
    }
  }
}
</style>
